import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
const path = "/workspace/organization";

export const workspaceOrganization = createCrudVuexModule({
  path: path,
  namespaced: true,

  state: { selected: null, editedOrganization: null },
  getters: {
    selected: (state) => state.selected,
    editedOrganization: (state) => state.editedOrganization,
    isEditMode: (state) => !!state.editedOrganization?._id,
  },
  mutations: {
    selected: (state, value) => {
      state.selected = {
        ...value,
        roles: value.roles?.map((r) => ({ _id: r._id, name: r.name, permissions: r.permissions?.map((rp) => ({ definiton: rp.definition, name: rp.name })) })),
        workspace: {
          _id: value.workspace?._id,
          name: value.workspace?.name,
        },
      };
    },
    reset: (state) => {
      state.selected = null;
      state.editedOrganization = null;
    },
    editedOrganization: (state, value) => (state.editedOrganization = value),
  },
  actions: {
    async save({ dispatch }, payload) {
      if (payload.organization._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },
    /**
     * Oluşturma PLATFORM ucuna gider: `/workspace/organization` yolunda yalnız PUT (güncelleme) tanımlı,
     * POST yok — jenerik crud modülü oraya POST attığı için 404 dönüyordu. Yük şekli `POST /organization`
     * ucunun beklediğiyle birebir aynı: `{ item: { organization, workspace } }`.
     */
    async create({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/organization", { item: { organization: payload.organization, workspace: payload.workspace } });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });
        const organization = { ...payload.organization, workspace: payload.workspace };

        const response = await rest.put(`${path}`, { item: { organization } });

        commit("editedEntity", undefined);
        return response;
      } finally {
        // hata YUTULMAZ: yukarıdaki form yakalayıp mesajı gösteriyor (eskiden boş `catch` yüzünden
        // başarısız güncellemede de "İşlem başarılı" görünüyordu)
        commit("isUpdating", false);
      }
    },

    async paginate({ state, commit }, pagination) {
      commit("isLoading", true);
      try {
        commit("pagination", undefined);
        const response = await rest.post(`${path}/paginate`, { pagination });
        commit("pagination", response.data);

        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    selected({ commit }, organization) {
      commit("selected", organization);
    },

    async delete({ commit }, { id, ownerId }) {
      return rest.delete(`${path}/${id}`, { headers: { "owner-id": ownerId } });
    },
  },
});
